// Libs
import { FaUser } from "react-icons/fa";
import { IoNotifications } from "react-icons/io5";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Components
import Logo from "../Logo";
// UI-Components
import IconWrapper from "../../UI-Components/IconWraper";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../UI-Components/Select";
// Components
import Breadcrumbs from "../Breadcrumbs";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogIcon,
  DialogTitle,
} from "../../UI-Components/Dialog";
import checkLogout from "../../Assets/Images/Logout_Icon.svg";
import { Button } from "../../UI-Components/Button";
import UpdateUserPassword from "../Profile/UpdateUserPassword";

const LogoutIcon = forwardRef<
  HTMLImageElement,
  React.ImgHTMLAttributes<HTMLImageElement>
>(({ ...props }, ref) => {
  return <img ref={ref} src={checkLogout} alt="logout" {...props} />;
});

LogoutIcon.displayName = "LogoutIcon";

export default function Header() {
  const navigate = useNavigate();
  const [isLogoutDialog, setLogoutDialogOpen] = useState<boolean>(false);
  const [isChangePassWordDialog, setChangePassWordDialogOpen] =
    useState<boolean>(false);

  // Handle Logout Cancel Button
  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  // Handle Logout Button
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  // Handle Cancel Update Password Button
  const handleCancelUpdatePassword = () => {
    setChangePassWordDialogOpen(false);
  };

  // Handle Profile Item State Dialog And Navigation
  const handleprofileItem = (value: string) => {
    switch (value) {
      case "userPass":
        setChangePassWordDialogOpen(true);
        break;
      case "updateUserProfile":
        navigate(`/profile/${value}`, { replace: true });
        break;
      case "logout":
        setLogoutDialogOpen(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleprofileItem("");
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="grid grid-cols-12 gap-3 bg-primary p-4 h-[10vh]">
        <div className="col-span-2 place-items-center place-content-center md:px-3">
          <Logo />
        </div>
        <div className="col-span-10">
          <div className="flex justify-between items-center h-full px-2">
            <div>
              <Breadcrumbs />
            </div>
            <div className="grid grid-cols-4 gap-2">
              <div className="col-span-2 px-2">
                <IconWrapper
                  icon={<IoNotifications className="text-icon" size={20} />}
                  variant={"default"}
                />
              </div>
              <div className="col-span-2 px-2 profileDrop">
                <Select onValueChange={handleprofileItem} value="">
                  <SelectTrigger
                    aria-label="User Options"
                    isIconRequired={false}
                    className="border-0 bg-transparent shadow-none p-0"
                  >
                    <IconWrapper
                      icon={<FaUser className="text-icon" size={20} />}
                      variant="default"
                    />
                  </SelectTrigger>

                  <SelectContent className="right-[15%] bg-dashboard text-secondary">
                    <SelectItem
                      className="hover:bg-white hover:text-primary"
                      value="updateUserProfile"
                    >
                      Update User Profile
                    </SelectItem>
                    <SelectItem
                      className="hover:bg-white hover:text-primary"
                      value="userPass"
                    >
                      Update User Password
                    </SelectItem>
                    <SelectItem
                      className="hover:bg-white hover:text-primary"
                      value="logout"
                    >
                      Logout
                    </SelectItem>
                  </SelectContent>
                  {/* 
                  <SelectContent>
                    {options.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}

                    <SelectSeparator />
                  </SelectContent> */}
                </Select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={isLogoutDialog} onOpenChange={handleLogoutCancel}>
        <DialogContent className="max-w-3xl">
          <DialogIcon>
            <LogoutIcon className="mt-4" />
          </DialogIcon>
          <DialogHeader>
            <DialogDescription className="hidden">
              Are you sure you want to logout?
            </DialogDescription>
            <DialogTitle>Are you sure you want to logout?</DialogTitle>
          </DialogHeader>
          <div className="flex justify-between gap-2">
            <Button
              className="w-full"
              variant={"default"}
              onClick={handleLogout}
            >
              Logout
            </Button>
            <Button
              className="w-full"
              variant={"cancel"}
              onClick={handleLogoutCancel}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={isChangePassWordDialog}
        onOpenChange={handleCancelUpdatePassword}
      >
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogDescription className="hidden">
              Update Password
            </DialogDescription>
            <DialogTitle className="py-0 font-semibold">
              Update Password
            </DialogTitle>
          </DialogHeader>
          <UpdateUserPassword
            handleCancelUpdatePassword={handleCancelUpdatePassword}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
